import { STRING_RESOURCES } from '@ala/shared-types';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'res',
})
export class ResourcePipe implements PipeTransform {
  // Token is an array of string that will be used to replace the placeholder(s) in the result string if there is any.
  // The placeholder should be %%.
  public transform(
    resId: string,
    pageId: string,
    token: Array<string> = []
  ): string {
    if (!resId || resId.length < 1) {
      return 'Resource Id Unknown';
    }
    if (!pageId || pageId.length < 1) {
      return 'Page Id Unknown';
    }
    if (STRING_RESOURCES[pageId]) {
      let returnStr = STRING_RESOURCES[pageId][resId];

      if (returnStr && token && token.length > 0) {
        returnStr = returnStr.replace(/%%/g, () => token.shift() || '%%');
      }
      return returnStr;
    } else {
      return '';
    }
  }
}
